import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft, List } from "@phosphor-icons/react";
import { Button } from "@filadd/phi-plus-core";
import { cx } from "@filadd/phi-plus-styled-system/css";
import { topBarRecipe } from "./recipes";
export const TopBar = ({ className, children, goBack, onOpenSidebar, }) => {
    const styles = topBarRecipe();
    return (_jsxs("div", { className: cx(styles.container, className), children: [_jsxs("div", { className: styles.left, children: [_jsx(Button, { variant: "ghost", type: "button", onClick: onOpenSidebar, className: styles.trigger, children: _jsx(List, {}) }), goBack && (_jsx(Button, { onClick: goBack, variant: "ghost", children: _jsx(ArrowLeft, { className: styles.backButtonArrow }) }))] }), children] }));
};
//# sourceMappingURL=TopBar.js.map